import { combineReducers } from "redux";
import auth from "./reducers/authReducer";
import dashboard from "./reducers/dashboardReducer";
import item from "./reducers/itemReducer";
import document from "./reducers/documentReducer";

const rootReducer = combineReducers({
    auth,
    dashboard,
    item,
    document,
});

export default rootReducer
